import styled from 'styled-components';
import RTECompose from 'contentful/RTE_compose';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';
import Container from './shared/container';
import Grid from './shared/grid';
import GridItem from './grid_item';

const GridSection = ({
  fields: {
    title,
    content,
    gridItems,
    columns,
    alignment,
    backgroundColor,
    fullWidth,
    cards,
    headerColumn,
    icons,
  },
  ...rest
}) => (
  <Container
    backgroundColor={backgroundColor}
    isFullWidth={fullWidth}
    className="grid-section"
    style={{ textAlign: !headerColumn && alignment }}
    {...rest}>
    <ParentGrid headerColumn={headerColumn}>
      <div>
        {title && <Title>{title}</Title>}
        {content && <RTECompose content={content} fieldType="content" />}
      </div>
      <Grid
        className="grid-section__content"
        cols={headerColumn ? 2 : columns || 3}
        colGap={32}
        rowGap={32}>
        {gridItems.map(({ fields = {}, sys: { id } }) => (
          <GridItem
            {...fields}
            isCard={cards}
            containerColor={backgroundColor}
            hasIcons={icons}
            alignment={alignment}
            key={id}
          />
        ))}
      </Grid>
    </ParentGrid>
  </Container>
);

const Title = styled.h2`
  font-weight: 800;
  font-size: ${toRem(32)};
  margin-bottom: 0;

  &:not(:only-child) {
    margin-bottom: ${toRem(32)};
  }
`;

const ParentGrid = styled.div`
  display: grid;
  gap: ${toRem(56)};

  ${responsive('tabletSmall')} {
    grid-template-columns: ${({ headerColumn }) =>
      headerColumn ? '33% 1fr' : 'auto'};
  }
`;

export default GridSection;
